import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removePrefix'
})
export class RemovePrefixPipe implements PipeTransform {

  transform(value: any, prefix: string): string {
    if(value.length>0)
    {
      var datalist ='';
      value.forEach((element:any) => {
        console.log(element)
        datalist +=   element.startsWith(prefix) ? element.slice(prefix.length).trim() : element.trim()
        datalist +=', '
      });
      return datalist;
    }
    else
      return '-';
  }

}
